import React, { useEffect } from 'react'
import ym from 'react-yandex-metrika'
import { translate } from 'react-i18next'
import { Helmet } from 'react-helmet'
import './style.css'

import Logo from './assets/logo.png'
import Boss from './assets/image1.jpg'

import Magazine_1280w from './assets/magazine-1280w.png'
import Magazine_768w from './assets/magazine-768w.png'
import Magazine_480w from './assets/magazine-480w.png'

import Screenshot_1280w from './assets/screenshotes-1280w.png'
import Screenshot_768w from './assets/screenshotes-768w.png'
import Screenshot_480w from './assets/screenshotes-480w.png'
import Feedback from '../../../Feedback'

const DS = ({ t }) => {

    useEffect(() => {
        document.body.classList.add('ds')
        ym('hit', '/our-works/direct-scouting-center')
        return () => {
            document.body.classList.remove('ds')
        }
    }, [])

    return (
        <div className="app__content--project">
            <Helmet>
                <title>{ t('ds.name') }</title>
            </Helmet>
            <main className="content__ds">
                <div className="content__ds--intro mt-4">
                    <div className="content__ds--logo-container">
                        <img src={ Logo } alt={ t('ds-title') } className="content__ds--logo" />
                    </div>
                    <div className="content__ds--text">
                        <p className="content__ds--p">{ t('ds.text1') }</p>
                        <p className="content__ds--p">{ t('ds.text2') }</p>
                    </div>
                </div>

                <div className="content__ds--link">
                    <a
                        href="//direct-scouting.ru?utm_source=clockwork.one&utm_medium=project_description"
                        target="_blank"
                        rel="nofollow noreferrer noopener">
                        direct-scouting.ru
                    </a>
                </div>

                <div className="content__ds--fluid">
                    <img src={ Boss } alt="Hugo Boss" className="content__ds--image" />
                </div>

                <div className="content__ds--issue">
                    <div>
                        <h2 className="content__ds--h2">{ t('issue') }</h2>
                    </div>
                    <div className="content__ds--text">
                        <p className="content__ds--p">{ t('ds.issue') }</p>
                    </div>
                </div>

                <div className="content__ds--fluid">
                    <img
                        srcSet={ `
                ${ Magazine_480w } 480w,
                ${ Magazine_768w } 768w,
                ${ Magazine_1280w } 1280w` }
                        sizes="100vw"
                        src={ Magazine_480w }
                        alt="Magazine"
                        className="content__ds--image" />
                </div>

                <div className="content__ds--solve">
                    <div>
                        <h2 className="content__ds--h2">{ t('solve') }</h2>
                    </div>
                    <div className="content__ds--text">
                        <p className="content__ds--p">{ t('ds.solve') }</p>
                    </div>
                </div>

                <div className="content__ds--fluid">
                    <img
                        srcSet={ `
                ${ Screenshot_480w } 480w,
                ${ Screenshot_768w } 768w,
                ${ Screenshot_1280w } 1280w` }
                        sizes="100vw"
                        src={ Screenshot_480w }
                        alt="Direct Scouting Center"
                        className="content__ds--image" />
                </div>

                <section className="m-5 ma">
                    <Feedback />
                </section>
            </main>
        </div>
    )
}

export default translate('translations')(DS)



// WEBPACK FOOTER //
// ./src/Pages/Projects/DS/index.js